module.exports = __webpack_public_path__ + "img/performanze.42b0d5c0.png";